import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import UsersPage from '@pages/-[lang]/c/[orgId]/[portalId]/users.tsx';
import { useUserStore } from '@features/client/users/userStore.ts';

const clientUsersSearchSchema = z.object({
  search: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type ClientUsersSearch = z.infer<typeof clientUsersSearchSchema>;

export const Route = createFileRoute('/c/$orgId/$portalId/users')({
  validateSearch: search => clientUsersSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { search, page, size } = ctx.search;
    useUserStore.getState().fetchUsers({
      search,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <UsersPage />;
}
